import {
  AnyAction, Dispatch, Middleware, configureStore,
} from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { createLogger } from 'redux-logger';
import envReader from '../config/envReader';
import { modalSheetSlice } from './slices/modalSheet.slice';

const logger = createLogger() as Middleware<object, any, Dispatch<AnyAction>>;

const store = configureStore({
  reducer: {
    modalSheet: modalSheetSlice.reducer,
  },
  middleware: (getDefaultMiddleware) => {
    const middleware = getDefaultMiddleware();

    if (envReader.DEV) middleware.push(logger);

    return middleware;
  },
  devTools: envReader.DEV,
});

export type RootState = ReturnType<typeof store.getState>;
export default store;

setupListeners(store.dispatch);
